import { Consent } from '../../../entities/Consent';
import { ConsentStorePort } from '../../ports/ConsentStorePort';

export class AddDataProcessingAgreementToOnboardingStoreUseCase {
  constructor(private consentStore: ConsentStorePort) {}

  execute(version: string) {
    const consent = this.buildConsent(version);
    this.consentStore.addConsent(consent);
  }

  private buildConsent(version: string): Consent {
    return {
      type: 'data_processing_agreement',
      version: version,
      dateSigned: new Date().toISOString().split('.')[0] + 'Z'
    };
  }
}
